/**
 * Created by fan on 3/13/17.
 */
angular.module('smartorg.r6.cmpts.password', []);
require('./password-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.cmpts.password';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/components/password/app/js/plumbing/app.js